import { store } from '@betacrew/jars-flux'

export const componentKey = "PAYER_SECTION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload;
        }
    },
    initialReducerState: {
        selectedPayer: {}
    }
});

export const { setSelectedPayer } = actions;